import React from 'react';
import '../assets/styles/Hero.css';
import TypingText from './TypingText';

const InitialHome = ({ title, subtitle, subtitleTexto, backgroundImage }) => {
  return (
    <section 
      className="hero-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="container">
        <div className="hero-content">
          <span className="hero-eyebrow">MDA ENERGIA SOLAR · GOIÁS</span>
          <h1>{title}</h1>
          <h3>{subtitleTexto}</h3>
          <TypingText  text={subtitle} />
          <div className="hero-actions">
            <a className="hero-cta" href="https://wa.me/5562981368378" target="_blank" rel="noreferrer">Simule sua economia <span aria-hidden="true">↗</span></a>
            <a className="hero-link" href="#economia">Veja como funciona</a>
          </div>
        </div>          
      </div>
    </section>
  );
};

export default InitialHome;
